import React from 'react';
import ionOpenOutline from '../../../../assets/Quotes/ionOpenOutline.svg';
import ionOpenOutlineDark from '../../../../assets/Quotes/IonOpenOutlineDark.svg';
import { useTheme } from '../../../../context/ThemeContext';

const HowDoThesePlansWork = props => {
  const { theme } = useTheme();
  const iconSrc = theme === 'dark' ? ionOpenOutlineDark : ionOpenOutline;

  return (
    <div className={`howDoThesePlansWork fs-18 d-flex align-items-center justify-content-between ${props.className} fw-600`} onClick={()=> props.togglePlanModal()}>        
      How do these plans work?
      <img src={iconSrc} alt="" />
  </div>
  );
};

export default HowDoThesePlansWork;
